import { UsaTodayAdVideo } from "../common/UsaTodayCompat";

export { UsaTodayAdVideo } from "../common/UsaTodayCompat";
export type {
  UsaTodayVideoCompletion,
  UsaTodayVideoConfig,
} from "../common/UsaTodayCompat";

interface UsaTodayVideoGlobal {
  AdVideo: typeof UsaTodayAdVideo;
  ready?: (constructor: typeof UsaTodayAdVideo, format: "video") => void;
}

const ads = window.__ark_ads__ as unknown as UsaTodayVideoGlobal;

// Unlike the generic entrypoint, the deployed bundle intentionally replaces a
// pre-existing constructor and notifies the host loader once it is ready.
ads.AdVideo = UsaTodayAdVideo;
ads.ready ||= () => undefined;
ads.ready(UsaTodayAdVideo, "video");
